import enTranslation from './en.json';

// Only English (the default and fallback language) ships in the main bundle.
// The others are separate ~10 KB chunks fetched on demand by the backend in
// i18n.ts — bundling all 8 used to be ~80 KB (gzip) of the main bundle.
export const bundledResources = {
  en: { translation: enTranslation },
} as const;

export const translationLoaders: Record<string, () => Promise<Record<string, unknown>>> = {
  fr: () => import('./fr.json').then((m) => m.default),
  nl: () => import('./nl.json').then((m) => m.default),
  es: () => import('./es.json').then((m) => m.default),
  de: () => import('./de.json').then((m) => m.default),
  it: () => import('./it.json').then((m) => m.default),
  pt: () => import('./pt.json').then((m) => m.default),
  ar: () => import('./ar.json').then((m) => m.default),
};

export const supportedLanguages = ['en', 'fr', 'nl', 'es', 'de', 'it', 'pt', 'ar'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];
